import React, { useEffect, useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import { fetchContactServicesListServices, LabelDto } from "src/app/api/ContactServiceApi";
import { useAppState } from "src/app/state/StateProvider";
import AppSelectFormik from "src/commun/composants/formulaire/formik/fields/AppSelectFormik";
import { ContactServiceFormData } from "src/pages/contactservice/useValidationSchemaContactService";
import AppTextareaFormik from "src/commun/composants/formulaire/formik/fields/AppTextareaFormik";
import parse from "html-react-parser";


const ContactServiceFormContent = () => {
  const [{ employeurContextuel, configuration }] = useAppState();

  const { tString } = useAppText();
  const { dirty, submitCount, submitForm } = useFormikContext<ContactServiceFormData>();

  const [{ langue }] = useAppState();

  const [listContactServices, setListContactServices] = useState<LabelDto[]>([]);

  useEffect(() => {
    // On prend la CIAM par defaut pour les comptes perso
    fetchContactServicesListServices(langue, employeurContextuel?.agence || "CIAM").then(res =>
      setListContactServices(res),
    );
  }, [langue]);


  return (
    <>
      <h2 className="appTitle">{tString("contactservice.titre")}</h2>
      <div className="input mt-2 mb-5">
        <div>{tString("contactservice.explicatif")}</div>
      </div>
      <div className="input mt-2 mb-10">
        <div>{parse(tString("contactservice.explicatif2", {
          urlAvs: "<a href='"+configuration.urlMessagerieAvs+(employeurContextuel?employeurContextuel.noEmployeur: "")+"'>"+ tString('contactservice.messageAvs') +"</a>",
          urlPp: "<a href='"+configuration.urlMessageriePp+(employeurContextuel?employeurContextuel.uuidEmployeur: "")+"'>"+ tString('contactservice.messagePp') +"</a>"}))}</div>
      </div>
      <div className="input mt-3 mb-5 ">
        <div style={{ marginLeft: "10px", marginBottom: "10px" }}>{tString("contactservice.form.service")} *</div>
        <AppSelectFormik
          options={
            listContactServices.map(p => ({ label: p.value, value: p.key }))
          }
          name="codeService"
          formulaireSoumis={submitCount > 0}
          defaultValue={"contactservice.form.service.select"}
        />
      </div>
      <div className="input mt-3 mb-5 ">
        <div style={{ marginLeft: "10px", marginBottom: "10px" }}>{tString("contactservice.form.message")} *</div>
        <AppTextareaFormik
          name="message"
          formulaireSoumis={submitCount > 0}
          maxlength={500}
        />
      </div>
      <input
        className="btn__primary mt-3  btn--full--xs"
        type="submit"
        name="submit"
        disabled={!dirty}
        onClick={submitForm}
        value={tString("contactservice.action.envoyer")}
      />
    </>
  );
};

export default ContactServiceFormContent;